import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ProjectDetail from "@/pages/project/page";
import AdminLogin from "@/pages/admin/login/page";
import AuthGuard from "@/pages/admin/components/AuthGuard";
import AdminLayout from "@/pages/admin/components/AdminLayout";
import Dashboard from "@/pages/admin/dashboard/page";
import Proyectos from "@/pages/admin/proyectos/page";
import Servicios from "@/pages/admin/servicios/page";
import Tecnologias from "@/pages/admin/tecnologias/page";
import Redes from "@/pages/admin/redes/page";
import Contenido from "@/pages/admin/contenido/page";
import Solicitudes from "@/pages/admin/solicitudes/page";
import Media from "@/pages/admin/media/page";
import Marca from "@/pages/admin/marca/page";
import Apariencia from "@/pages/admin/apariencia/page";
import Seo from "@/pages/admin/seo/page";
import Historial from "@/pages/admin/historial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/proyecto/:slug",
    element: <ProjectDetail />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AuthGuard />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Dashboard /> },
          { path: "proyectos", element: <Proyectos /> },
          { path: "servicios", element: <Servicios /> },
          { path: "tecnologias", element: <Tecnologias /> },
          { path: "redes", element: <Redes /> },
          { path: "contenido", element: <Contenido /> },
          { path: "solicitudes", element: <Solicitudes /> },
          { path: "media", element: <Media /> },
          { path: "marca", element: <Marca /> },
          { path: "apariencia", element: <Apariencia /> },
          { path: "seo", element: <Seo /> },
          { path: "historial", element: <Historial /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;